import React, {useState} from 'react'
import {connect} from 'react-redux'

import {Icon} from '@lazarusai/forms-ui-components'

import '../styles/FileUpload.css'
import SelectPill from './SelectPill'

function FileUpload(props) {
  const [fileDrag, setFileDrag] = useState(false)
  const [moveInput, setMoveInput] = useState(false)

  function dragEnter(e) {
    e.preventDefault()
    setFileDrag(true)
    setMoveInput(true)
  }

  function dragDrop(e) {
    e.preventDefault()
    // e.target.value = null
    e.stopPropagation()
    setFileDrag(false);
    setMoveInput(false);
    props.onChangeFile(e)
  }

  function dragLeave(e) {
    e.preventDefault()
    setFileDrag(false)
    setMoveInput(false);
  }

  function dragOver(e) {
    e.preventDefault()
    e.stopPropagation()
    setFileDrag(true)
  }

  return (
    <div className={`file-upload ${fileDrag ? 'border-highlight' : ''}`}>
      <label
        htmlFor='file-input'
        onDragEnter={dragEnter}
        onDrop={dragDrop}
        onDragLeave={dragLeave}
        onDragOver={dragOver}
      >
        <div className='label-contents'>
          {/* <div className='title-container'>
            <Icon
              icon={'file-add-outline'}
              key={'upload-title-icon'}
              fill='var(--colors-brand-light-blue)'
            />
            <span
              className='section-title'
            >
              File Upload
            </span>
          </div> */}
          <div className='body-container'>
            <div className='body-contents'>
              <div className='bottom-aligned-div'>
                <Icon
                  icon={'upload-outline'}
                  key={'upload-icon'}
                />
              </div>
              <div className='text-center'>
                Choose a document file or drag it here
              </div>
              <div className='bottom-aligned-div'>
                <div className='select-div'>
                  <SelectPill
                    text={'Upload your file'}
                  />
                  {/* <SelectPill
                    text={'Use Example File'}
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </label>
      <input
        type='file'
        id='file-input'
        accept='.png, .jpg, .jpeg, .tiff, .tif, application/pdf'
        onChange={props.onChangeFile}
        onClick={(e) => {
          e.target.value = null
        }}
        style={{zIndex: moveInput ? '5' : '-1'}}
        onDrop={dragDrop}
        onDragLeave={dragLeave}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
})

export default connect(
    mapStateToProps,
    {},
)(FileUpload)
